import { type CouponId, type CouponIndex } from '../../../../schema/coupon/entry.js';
import type { WalletType } from '../../../../schema/frameworks/entry.js';
import type { ActivatedDrawId } from '../../../../schema/marketplace/entry.js';
import type { IUpdateCouponWalletUseCase } from '../../../domain/entry.js';

export type IUpdateCouponWalletController = ReturnType<typeof updateCouponWalletController>;

type UpdateCouponWalletPayloadParams = ActivatedDrawId | WalletType;

type UpdateCouponWalletControllerArgs = {
  couponId: CouponId;
  couponIndices: CouponIndex[];
};

/**
 * Controller for updating a coupon wallet.
 *
 * @param updateCouponWalletUseCase Use case for updating a coupon wallet
 * @returns Controller executor function
 */
export function updateCouponWalletController(updateCouponWalletUseCase: IUpdateCouponWalletUseCase) {
  return function controller(
    payload: UpdateCouponWalletPayloadParams,
    { couponId, couponIndices }: UpdateCouponWalletControllerArgs
  ): boolean {
    let isUpdated = true;
    for (const couponIndex of couponIndices) {
      const isUpdatedValue = updateCouponWalletUseCase.execute({ couponId, couponIndex, payload });
      if (!isUpdatedValue) {
        isUpdated = false;
      }
    }
    return isUpdated;
  };
}
